/* eslint-disable no-mixed-operators */
import { getDiaStrTurno } from "../../../../global/utils/diasTurno";
import { amOrPm } from "../../../../global/utils/amOrPm";
import camelize from "../../../../global/utils/camelize";
import "./CardTurnoBody.css";
import MapPinnedIcon from "../../../assets/images/generico/MapPinnedIcon";
import MapIcon from "../../../assets/images/generico/MapIcon";

const CardTurnoBody = ({ turno }) => {
  return <div className="ptur-card-cardTurno-body">
    <div className="ptur-info">
      <span className="important-text">{getDiaStrTurno(turno.fecha)}</span>
      <span className="normal-text">{getDiaStrTurno(turno.fecha, true)}</span>
    </div>
    <div className="ptur-info">
      <span className="important-text">Horario:</span>
      <span className="normal-text">{turno.hora} {amOrPm(turno.hora)}</span>
    </div>
    <ul className="ptur-list">
      {turno.medico &&
        <li>
          <div className="ptur-info">
            <span className="normal-text">Especialista:</span>
            <span className="important-text">{camelize(turno.medico)}</span>
          </div>
        </li>
      }
      <li>
        <div className="ptur-info">
          <span className="normal-text">Tipo de Consulta:</span>
          {turno.videoConsulta ?
            <span className="important-text"> Video Consulta</span>
            :
            <span className="important-text"> Presencial</span>
          }
        </div>
      </li>
    </ul>
    <div className="ptur-info">
      <span className="important-text">Centro:</span>
      <span className="normal-text">{camelize(turno.centro)}</span>
    </div>
    <a
      className="ptur-info button c-latex30"
      rel="noreferrer noopener"
      target="_blank"
      href={`https://maps.google.com/?q=${turno.coordenadaGps}`}
    >
      <MapPinnedIcon />
      {turno.ubicacion}
    </a>
    {!turno.videoConsulta &&
      <a
        className="ptur-info button c-latex30"
        rel="noreferrer noopener"
        target="_blank"
        href={`https://www.google.com/maps/dir/?api=1&destination=${turno.coordenadaGps}&dir_action=navigate`}
      >
        <MapIcon />
        Ir desde mi ubicación
      </a>
    }
  </div>
};

export default CardTurnoBody;
